<fieldset [formGroup]="formGroup">
  <legend class="vtz-form__label" i18n="Form field label">Date of Birth
      <span class="vtz--red">*</span>
      @if (tooltipText.length > 0) {
<button id="tooltip-{{htmlIdPrefix}}"  class="vtz-tooltip"
      matTooltip="{{tooltipText}}"
      i18n-matTooltip="Tooltip information"
      matTooltipPosition="after"
      aria-label="Tooltip for input field"
      i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
      (click)="onTooltipClick($event)"></button>
}
    </legend>
  <div class="vtz-form__field-group">
    @if (dateParts.has('month')) {
      <div class="vtz-form__field-group-item">
        <label class="vtz-form__label" for="{{htmlIdPrefix}}-month">
          <span class="visuallyhidden" i18n="Form field label">Month</span> </label>
          <select class="vtz-form__select" formControlName="month" name="month" id="{{htmlIdPrefix}}-month" [attr.aria-required]="true"
            [ngClass]="{ 'vtz-form__input--error': monthField.touched && monthField.errors?.required }">
            <option value="null" i18n="Form field label">Month</option>
            <option [value]="1" i18n>January</option>
            <option [value]="2" i18n>February</option>
            <option [value]="3" i18n>March</option>
            <option [value]="4" i18n>April</option>
            <option [value]="5" i18n>May</option>
            <option [value]="6" i18n>June</option>
            <option [value]="7" i18n>July</option>
            <option [value]="8" i18n>August</option>
            <option [value]="9" i18n>September</option>
            <option [value]="10" i18n>October</option>
            <option [value]="11" i18n>November</option>
            <option [value]="12" i18n>December</option>
            </select
            >
          </div>
        }
        @if (dateParts.has('day')) {
          <div class="vtz-form__field-group-item">
            <label class="vtz-form__label" for="{{htmlIdPrefix}}-day">
              <span class="visuallyhidden" i18n="Form field label">Day</span>
            </label>
            <select class="vtz-form__select" formControlName="day" name="day" id="{{htmlIdPrefix}}-day" [attr.aria-required]="true"
              [ngClass]="{ 'vtz-form__input--error': dayField.touched && dayField.errors?.required }">
              <option [value]="null" i18n="Form field label">Day</option>
              @for (day of (daysInCurrentMonth | async); track day; let i = $index) {
                <option [value]="i + 1">
                  {{ i + 1 }}
                </option>
              }
            </select>
          </div>
        }
        @if (dateParts.has('year')) {
          <div class="vtz-form__field-group-item">
            <label class="vtz-form__label" for="{{htmlIdPrefix}}-year">
              <span class="visuallyhidden" i18n="Form field label">Year</span>
            </label>
            <select class="vtz-form__select" name="year" formControlName="year" id="{{htmlIdPrefix}}-year" [attr.aria-required]="true"
              [ngClass]="{ 'vtz-form__input--error': yearField.touched && yearField.errors?.required }">
              <option [value]="null" i18n="Form field label">Year</option>
              @for (i of allowedYears; track i) {
                <option [value]="i">{{i}}</option>
              }
            </select>
          </div>
        }
      </div>
    </fieldset>
    @if (formGroup.touched && anyFieldsMissing()) {
      <div role="alert">
        <span
        id="{{htmlIdPrefix}}_missing_msg" i18n="Invalid form field" class="vtz-form__error">
    All three date fields are required.
  </span>
      </div>

    }
